import React from 'react';
import Jeep from '../components/Jeep';

const JeepPage = () => {
  return (
    <div className="page-container">
      <Jeep />
    </div>
  );
};

export default JeepPage;